// DS: DEV6
import React from 'react';
import c from 'classnames';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import CloseIconBold from '../../../Icons/CloseBold';
import IconButton from '../../../Button/IconButton';
import s from './PopoverCard.scss';
export var PopoverCard = function (_a) {
    var className = _a.className, closeButtonClassName = _a.closeButtonClassName, _b = _a.withCloseButton, withCloseButton = _b === void 0 ? true : _b, onClose = _a.onClose, children = _a.children;
    return (React.createElement("div", { className: c(s['root'], className) },
        React.createElement(ThemeOverride, { className: s['theme-wrapper'], theme: ThemeOptions.LIGHT },
            withCloseButton && (React.createElement(IconButton, { className: c(s['close-button'], closeButtonClassName), onClick: onClose, noHoverEffect: true },
                React.createElement(CloseIconBold, null))),
            children)));
};
PopoverCard.displayName = 'PopoverCard';
export default PopoverCard;
//# sourceMappingURL=PopoverCard.js.map